import React, { useContext, useEffect, useState } from "react"
import { useLocation } from "@reach/router"
import { NavDropdown, Navbar, Dropdown } from "react-bootstrap"
import { getCurrentPageLanguage } from "../../linkUtils"
import { defaultLanguage, languageNames } from "../../i18n"
import { changeLocale } from "../../link"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGlobe } from "@fortawesome/pro-light-svg-icons"
import { useQueryParam, StringParam, JsonParam } from "use-query-params"
import { FirebaseContext } from "../../components/Firebase"
import "./language-switcher.css"

const LanguageSwitcher = (props) => {
  const { firebase } = useContext(FirebaseContext)
  const location = useLocation()
  const [currentLanguage, setCurrentLanguage] = useState(
    languageNames[defaultLanguage]
  )
  const [cssClass, setCssClass] = useState(true)
  const [displayLanguageDropdown, setDisplayLanguageDropdown] = useState(true)

  // URL search parameters for Algolia components
  const [queryFilters, setQueryFilters] = useQueryParam(
    "queryFilters",
    JsonParam
  )
  const [sortByPageQuery, setSortByPageQuery] = useQueryParam(
    "sortByPageQuery",
    StringParam
  )

  const loginSignUpPaths = [
    "/es-ES/login/individuals/",
    "/login/individuals/",
    "/signup/individuals/",
    "/es-ES/signup/individuals/",
    "/login/",
    "/es-ES/login/",
  ];
  const hideLanguageSwitcher = [
    "/educator/","/educator", "/educator/students/manage/", "/educator/students/manage", "/educator/students/group/",
    "/educator/students/group", "/educator/staff",
    "/educator/staff/", "/educator/students", "/educator/students/", "/educator/analytics", "/educator/analytics/"
  ];


  useEffect(() => {
    if (location?.pathname) {
      if (loginSignUpPaths.includes(location.pathname)) {
        setCssClass(false)
      } else {
        setCssClass(true)
      }
    }
  }, [location]);

  useEffect(() => {
    // Check if the current path is in the list of hidden paths to hide the language switcher
    const shouldHideLanguageSwitcher = hideLanguageSwitcher.some((path) =>
      location.pathname.startsWith(path)
    );
    setDisplayLanguageDropdown(!shouldHideLanguageSwitcher);
  }, [location]);

  useEffect(() => {
    const lang = getCurrentPageLanguage(location.pathname)
    setCurrentLanguage(languageNames[lang])
  }, [location])


  // Clear filters and change locale
  const handleLocaleChangeAndClearFilters = async (languageKey) => {
    setQueryFilters(undefined)
    setSortByPageQuery(undefined)
    changeLocale(languageKey)

    try {
      await firebase.updateProfile({
        data: { language: languageKey === "es-ES" ? "esp" : "eng" },
      })
    } catch (error) {
      console.error("Error updating user profile language", error)
    }
  }

  return (
    <div
      className={`${props.className} printer-none` || "printer-none"}
      style={{ display: 'flex', alignItems: 'center', marginLeft: props.sideNav || props.footer ? 0 : '.5rem' }}
    >
      {!props.sideNav && <FontAwesomeIcon icon={faGlobe} color="white" />}

        <NavDropdown
          alignRight
          title={props.sideNav ? (
            <>
              <FontAwesomeIcon icon={faGlobe} className="wings-app-nav-item-icon" />
                <span className="wings-app-nav-item-label">{currentLanguage}</span>
            </>
          ) : currentLanguage}
          drop={props.sideNav ? 'right' : props.top ? 'down' : 'up'}
          id={props.footer ? '' : `language-switcher`}
          onClick={() => {
            document.body.click()
          }}
        >
          
          {Object.keys(languageNames).map(languageKey => (
            <a
              key={languageKey}
              onClick={() => handleLocaleChangeAndClearFilters(languageKey)}
              className="dropdown-item menu-class"
            >
              {languageNames[languageKey]}
            </a>
          ))}
        </NavDropdown>

    </div>
  )
}

export default LanguageSwitcher
